import { onBeforeUnmount, onMounted, ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { useDebugger } from '@/shared/composables/useDebugger.js'

export const useNotificationsContainerPosition = (id: string) => {
  const { $debug } = useDebugger()
  const animationFrameId = ref(null)

  const handleScrollListener = () => {
    if (animationFrameId.value) {
      window.cancelAnimationFrame(animationFrameId.value)
    }
    animationFrameId.value = window.requestAnimationFrame(
      recalculateContainerPosition,
    )
  }

  // We don't want to cover the navbar when a notification is shown
  // That's why we need to recalculate the margin-top of the notifications container
  const recalculateContainerPosition = () => {
    const mainNavigation = document.getElementById('top-page-content')
    if (!mainNavigation) return
    const notificationsContainer = document.getElementById(id)
    const scrollOffset = window.scrollY
    const navbarHeight = mainNavigation.offsetHeight

    const DEFAULT_MARGIN_TOP = 4
    const isNavbarVisible = navbarHeight > scrollOffset
    const marginTopToAdd = isNavbarVisible
      ? navbarHeight - scrollOffset + DEFAULT_MARGIN_TOP
      : DEFAULT_MARGIN_TOP
    if (!notificationsContainer) return
    notificationsContainer.style.marginTop = `${marginTopToAdd}px`

    $debug(`[NotificationsContainer - ${id}] Recalculated container position`)
  }

  onMounted(() => {
    document.addEventListener('scroll', handleScrollListener)
    // We have "Switch to mentor" banner, and it shows after user successfully send a request
    // So just to make sure notifications are not overlapping with the navbar
    // We always recalculate its position after successful request
    router.on('success', handleScrollListener)
    handleScrollListener()
  })
  onBeforeUnmount(() => {
    document.removeEventListener('scroll', handleScrollListener)
  })
}
